import React, { FC } from 'react'

import { IconStateErrorInverseProps } from './IconStateErrorInverse.types'
import * as Styled from './styles/IconStateErrorInverse.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStateErrorInverse: FC<IconStateErrorInverseProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStateErrorInverseProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconStateErrorInverseProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 143' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M79.968 107.84a6.554 6.554 0 1 1 0 13.11 6.554 6.554 0 0 1 0-13.11Zm6.498-63.946-1.062 24.314-1.05 24.044s.06 1.234-.518 2.494c-.626 1.525-2.125 2.608-3.868 2.608-1.744 0-3.242-1.083-3.868-2.608-.58-1.26-.519-2.494-.519-2.494l-1.05-24.044-1.061-24.314c-.282-6.455 5.984-6.828 6.19-6.839h.611s6.481.276 6.195 6.839Zm71.651 78.043-33.262-57.613L91.592 6.71c-5.166-8.948-18.082-8.948-23.249 0L35.081 64.324 1.818 121.937c-5.166 8.948 1.292 20.133 11.625 20.133h133.05c10.333 0 16.79-11.185 11.624-20.133'
          fill='#fff'
          fillRule='evenodd'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStateErrorInverse
